const { createReducer } = require('../helpers')
const {
  // For Admin Panel
  GET_FILE_ADMIN,
  GET_FILE_ADMIN_SUCCESS,
  GET_FILE_ADMIN_ERROR,
  GET_FILE_ADMIN_RESET,

  // For Admin Panel - Getting file and pushing into array
  GET_FILE_AND_APPEND_ADMIN,
  GET_FILE_AND_APPEND_ADMIN_SUCCESS,
  GET_FILE_AND_APPEND_ADMIN_ERROR,
  GET_FILE_AND_APPEND_ADMIN_RESET,

  // For Users - Getting file and pushing into array
  GET_FILE_AND_APPEND_USER,
  GET_FILE_AND_APPEND_USER_SUCCESS,
  GET_FILE_AND_APPEND_USER_ERROR,
  GET_FILE_AND_APPEND_USER_RESET,

  // For Admin Panel
  GET_FILES_URL_ADMIN,
  GET_FILES_URL_ADMIN_SUCCESS,
  GET_FILES_URL_ADMIN_ERROR,
  GET_FILES_URL_ADMIN_RESET,

  // For Admin Panel
  UPLOAD_FILES_ADMIN,
  UPLOAD_FILES_ADMIN_SUCCESS,
  UPLOAD_FILES_ADMIN_ERROR,
  UPLOAD_FILES_ADMIN_RESET,

  GET_FILE,
  GET_FILE_SUCCESS,
  GET_FILE_ERROR,
  GET_FILE_RESET,
  // Use-case -> when needs to get file on multiple places in same component
  GET_FILE_TWO,
  GET_FILE_TWO_SUCCESS,
  GET_FILE_TWO_ERROR,
  GET_FILE_TWO_RESET,

  GET_MULTIPLE_FILE,
  GET_MULTIPLE_FILE_SUCCESS,
  GET_MULTIPLE_FILE_ERROR,
  GET_MULTIPLE_FILE_RESET,

  UPLOAD_FILES,
  UPLOAD_FILES_SUCCESS,
  UPLOAD_FILES_ERROR,
  UPLOAD_FILES_RESET,
  GET_FILES_URL,
  GET_FILES_URL_SUCCESS,
  GET_FILES_URL_ERROR,
  GET_FILES_URL_RESET,
  GET_REFERRAL_FILE,
  GET_REFERRAL_FILE_SUCCESS,
  GET_REFERRAL_FILE_ERROR,
  GET_REFERRAL_FILE_RESET,
  GET_MC_FILE,
  GET_MC_FILE_SUCCESS,
  GET_MC_FILE_ERROR,
  GET_MC_FILE_RESET,
  GET_PRESCRIPTION_FILE,
  GET_PRESCRIPTION_FILE_SUCCESS,
  GET_PRESCRIPTION_FILE_ERROR,
  GET_PRESCRIPTION_FILE_RESET,
} = require('./constants')

const initialState = {
  getFileAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  // For Admin Panel - Getting file and pushing into array
  getFileAndAppendAdmin: {
    data: [],
    loading: false,
    error: null,
  },
  // For Users - Getting file and pushing into array
  getFileAndAppendUser: {
    data: [],
    loading: false,
    error: null,
  },
  uploadFilesAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  getUploadFilesUrlStateAdmin: {
    data: null,
    loading: false,
    error: null,
  },
  getFile: {
    data: null,
    loading: false,
    error: null,
  },
  getFileTwo: {
    data: null,
    loading: false,
    error: null,
  },
  getMultipleFile: {
    data: [],
    loading: false,
    error: null,
  },
  uploadFiles: {
    data: null,
    loading: false,
    error: null,
  },
  getUploadFilesUrlState: {
    data: null,
    loading: false,
    error: null,
  },
  getReferralFileState: {
    data: null,
    loading: false,
    error: null,
  },
  getMCFileState: {
    data: null,
    loading: false,
    error: null,
  },
  getPrescriptionFileState: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer({
  [GET_FILE_ADMIN]: draft => ({
    getFileAdmin: {
      ...draft.getFileAdmin,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_FILE_ADMIN_SUCCESS]: (draft, action) => ({
    getFileAdmin: {
      ...draft.getFileAdmin,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_FILE_ADMIN_ERROR]: (draft, action) => ({
    getFileAdmin: {
      ...draft.getFileAdmin,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILE_ADMIN_RESET]: () => ({
    getFileAdmin: { ...initialState.getFileAdmin },
  }),

  [GET_FILE_AND_APPEND_ADMIN]: draft => ({
    getFileAndAppendAdmin: {
      ...draft.getFileAndAppendAdmin,
      loading: true,
      error: null,
    },
  }),
  [GET_FILE_AND_APPEND_ADMIN_SUCCESS]: (draft, action) => ({
    getFileAndAppendAdmin: {
      ...draft.getFileAndAppendAdmin,
      data: [...draft.getFileAndAppendAdmin.data, action.payload.data.request.data],
      loading: false,
    },
  }),
  [GET_FILE_AND_APPEND_ADMIN_ERROR]: (draft, action) => ({
    getFileAndAppendAdmin: {
      ...draft.getFileAndAppendAdmin,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILE_AND_APPEND_ADMIN_RESET]: () => ({
    getFileAndAppendAdmin: { ...initialState.getFileAndAppendAdmin },
  }),

  [GET_FILE_AND_APPEND_USER]: draft => ({
    getFileAndAppendUser: {
      ...draft.getFileAndAppendUser,
      loading: true,
      error: null,
    },
  }),
  [GET_FILE_AND_APPEND_USER_SUCCESS]: (draft, action) => ({
    getFileAndAppendUser: {
      ...draft.getFileAndAppendUser,
      data: [...draft.getFileAndAppendUser.data, action.payload.data.request.data],
      loading: false,
    },
  }),
  [GET_FILE_AND_APPEND_USER_ERROR]: (draft, action) => ({
    getFileAndAppendUser: {
      ...draft.getFileAndAppendUser,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILE_AND_APPEND_USER_RESET]: () => ({
    getFileAndAppendUser: { ...initialState.getFileAndAppendUser },
  }),

  [UPLOAD_FILES_ADMIN]: draft => ({
    uploadFilesAdmin: {
      ...draft.uploadFilesAdmin,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPLOAD_FILES_ADMIN_SUCCESS]: (draft, action) => ({
    uploadFilesAdmin: {
      ...draft.uploadFilesAdmin,
      data: action.payload.data,
      loading: false,
    },
  }),
  [UPLOAD_FILES_ADMIN_ERROR]: (draft, action) => ({
    uploadFilesAdmin: {
      ...draft.uploadFilesAdmin,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPLOAD_FILES_ADMIN_RESET]: () => ({
    uploadFilesAdmin: { ...initialState.uploadFilesAdmin },
  }),

  [GET_FILES_URL_ADMIN]: draft => ({
    getUploadFilesUrlStateAdmin: {
      ...draft.getUploadFilesUrlStateAdmin,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_FILES_URL_ADMIN_SUCCESS]: (draft, action) => ({
    getUploadFilesUrlStateAdmin: {
      ...draft.getUploadFilesUrlStateAdmin,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_FILES_URL_ADMIN_ERROR]: (draft, action) => ({
    getUploadFilesUrlStateAdmin: {
      ...draft.getUploadFilesUrlStateAdmin,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILES_URL_ADMIN_RESET]: () => ({
    getUploadFilesUrlStateAdmin: { ...initialState.getUploadFilesUrlStateAdmin },
  }),

  [GET_FILE]: draft => ({
    getFile: {
      ...draft.getFile,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_FILE_SUCCESS]: (draft, action) => ({
    getFile: {
      ...draft.getFile,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_FILE_ERROR]: (draft, action) => ({
    getFile: {
      ...draft.getFile,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILE_RESET]: () => ({
    getFile: { ...initialState.getFile },
  }),

  // Use-case -> when needs to get file on multiple places in same component
  [GET_FILE_TWO]: draft => ({
    getFileTwo: {
      ...draft.getFileTwo,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_FILE_TWO_SUCCESS]: (draft, action) => ({
    getFileTwo: {
      ...draft.getFileTwo,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_FILE_TWO_ERROR]: (draft, action) => ({
    getFileTwo: {
      ...draft.getFileTwo,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILE_TWO_RESET]: () => ({
    getFileTwo: { ...initialState.getFileTwo },
  }),

  [GET_MULTIPLE_FILE]: draft => ({
    getMultipleFile: {
      ...draft.getMultipleFile,
      data: [],
      loading: true,
      error: null,
    },
  }),
  [GET_MULTIPLE_FILE_SUCCESS]: (draft, action) => ({
    getMultipleFile: {
      ...draft.getMultipleFile,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_MULTIPLE_FILE_ERROR]: (draft, action) => ({
    getMultipleFile: {
      ...draft.getMultipleFile,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_MULTIPLE_FILE_RESET]: () => ({
    getMultipleFile: { ...initialState.getMultipleFile },
  }),

  [UPLOAD_FILES]: draft => ({
    uploadFiles: {
      ...draft.uploadFiles,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [UPLOAD_FILES_SUCCESS]: (draft, action) => ({
    uploadFiles: {
      ...draft.uploadFiles,
      data: action.payload.data,
      loading: false,
    },
  }),
  [UPLOAD_FILES_ERROR]: (draft, action) => ({
    uploadFiles: {
      ...draft.uploadFiles,
      loading: false,
      error: action.payload.error,
    },
  }),
  [UPLOAD_FILES_RESET]: () => ({
    uploadFiles: { ...initialState.uploadFiles },
  }),

  [GET_FILES_URL]: draft => ({
    getUploadFilesUrlState: {
      ...draft.getUploadFilesUrlState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_FILES_URL_SUCCESS]: (draft, action) => ({
    getUploadFilesUrlState: {
      ...draft.getUploadFilesUrlState,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_FILES_URL_ERROR]: (draft, action) => ({
    getUploadFilesUrlState: {
      ...draft.getUploadFilesUrlState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_FILES_URL_RESET]: () => ({
    getUploadFilesUrlState: { ...initialState.getUploadFilesUrlState },
  }),

  [GET_REFERRAL_FILE]: draft => ({
    getReferralFileState: {
      ...draft.getReferralFileState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_REFERRAL_FILE_SUCCESS]: (draft, action) => ({
    getReferralFileState: {
      ...draft.getReferralFileState,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_REFERRAL_FILE_ERROR]: (draft, action) => ({
    getReferralFileState: {
      ...draft.getReferralFileState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_REFERRAL_FILE_RESET]: () => ({
    getReferralFileState: { ...initialState.getReferralFileState },
  }),

  [GET_MC_FILE]: draft => ({
    getMCFileState: {
      ...draft.getMCFileState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_MC_FILE_SUCCESS]: (draft, action) => ({
    getMCFileState: {
      ...draft.getMCFileState,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_MC_FILE_ERROR]: (draft, action) => ({
    getMCFileState: {
      ...draft.getMCFileState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_MC_FILE_RESET]: () => ({
    getMCFileState: { ...initialState.getMCFileState },
  }),

  [GET_PRESCRIPTION_FILE]: draft => ({
    getPrescriptionFileState: {
      ...draft.getPrescriptionFileState,
      data: null,
      loading: true,
      error: null,
    },
  }),
  [GET_PRESCRIPTION_FILE_SUCCESS]: (draft, action) => ({
    getPrescriptionFileState: {
      ...draft.getPrescriptionFileState,
      data: action.payload.data,
      loading: false,
    },
  }),
  [GET_PRESCRIPTION_FILE_ERROR]: (draft, action) => ({
    getPrescriptionFileState: {
      ...draft.getPrescriptionFileState,
      loading: false,
      error: action.payload.error,
    },
  }),
  [GET_PRESCRIPTION_FILE_RESET]: () => ({
    getPrescriptionFileState: { ...initialState.getPrescriptionFileState },
  }),
}, initialState)
